import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import ErrorScreen, { HANDLED_ERRORS } from './ErrorScreen';
import { jsx as _jsx } from "react/jsx-runtime";
function HubErrorBoundary(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    renderCustomError: function renderCustomError(error) {
      if ('status' in error && error.status === 404) {
        return /*#__PURE__*/_jsx(ErrorScreen, {
          reason: "404"
        });
      } else if ('code' in error && typeof error.code === 'string' && HANDLED_ERRORS.includes(error.code)) {
        return /*#__PURE__*/_jsx(ErrorScreen, {
          reason: error.code
        });
      }
    },
    children: children
  });
}
export default HubErrorBoundary;